<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-6 col-12 mb-2">
                <h3 class="content-header-title mb-0">Insurance Item Categories</h3>
                <div class="row breadcrumbs-top">
                    <div class="breadcrumb-wrapper col-12">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="/">Home</a>
                            </li>
                            <li class="breadcrumb-item active">Insurance Item Categories
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>

        <div class="content-body">
            <section class="card">
                <div class="card-header">
                    <h4>Insurance Item Categories</h4>
                </div>

                <div class="card-body">
                    <vue-good-table
                        class="dataTable"
                        mode="remote"
                        :isLoading.sync="tableDataLoading"
                        :totalRows="totalRecords"
                        :pagination-options="paginationOptions"
                        @on-page-change="onPageChange"
                        @on-per-page-change="onPerPageChange"
                        @on-sort-change="onSortChange"
                        styleClass="vgt-table"
                        :columns="columns"
                        :rows="allInsuranceItemCategories"
                    >

                        <div slot="emptystate" class="loading-container">
                            <img src="/images/Spinner.svg" alt="">
                        </div>
                        <template slot="table-row" slot-scope="props">
                             <span v-if="props.column.field === 'sn'">
                                    {{ serialNo(props) }}
                             </span>
                            <span v-else-if="props.column.label === 'Name'">
                               <a :href="route('admin.insurance-item-categories.edit', props.row.id)">{{ props.row.name }}</a>
                            </span>
                            <span v-else-if="props.column.field === 'description'">
                                {{ props.row.description }}
                            </span>
                            <span v-else-if="props.column.field === 'is_active'"
                                  :class="'badge-glow badge badge-' + (props.row.is_active ? 'primary' : 'secondary')"
                            >
                                {{ props.row.is_active ? 'active' : 'inactive' }}
                            </span>
                            <span v-else-if="props.column.field === 'action'">
                                <span class="dropdown">
                                    <a id="btnSearchDrop2" data-toggle="dropdown" aria-haspopup="true"
                                       aria-expanded="false" class="dropdown-toggle dropdown-menu-right"><i
                                        class="fa fa-ellipsis-v"></i></a>
                                    <span aria-labelledby="btnSearchDrop2"
                                          class="dropdown-menu mt-1 dropdown-menu-right"
                                          x-placement="bottom-end"
                                          style="position: absolute; will-change: transform; top: 0px; left: 0px; transform: translate3d(0px, 19px, 0px);"
                                          x-out-of-boundaries=""
                                    >
                                        <a :href="route('admin.insurance-item-categories.edit', props.row.id)"
                                           class="dropdown-item edit"><i class="feather icon-edit-2"></i>
                                            Edit
                                        </a>
                                    </span>
                                </span>
                            </span>
                        </template>
                    </vue-good-table>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout';

export default {
    metaInfo: {title: 'Insurance Item Categories'},
    props: ['categories'],
    layout: Layout,

    data: () => ({
        filter: {},
        isLoadingFilter: false,
        allInsuranceItemCategories: [],
        totalRecords: 0,
        serverParams: {
            page: 1,
            perPage: 10
        },
        paginationOptions: {
            enabled: true,
            mode: 'pages',
            perPage: 10,
            perPageDropdown: [5, 10, 20, 50, 100, 200],
            dropdownAllowAll: false,
        },
        columns: [
            {label: 'S/N', field: 'sn'},
            {label: 'Name', field: 'name'},
            {label: 'Description', field: 'description'},
            {label: 'Status', field: 'is_active'},
            {label: 'Action', field: 'action', sortable: false},
        ],
        tableDataLoading: false,
        searchTerm: '',
    }),
    mounted() {
        this.allInsuranceItemCategories = this.categories.data;
        this.totalRecords = this.categories.total
    },
    methods: {
        updateParams(newProps) {
            this.serverParams = Object.assign({}, this.serverParams, newProps);
        },
        onPageChange(params) {
            this.updateParams({page: params.currentPage});
            this.paginatedData();
        },
        onPerPageChange(params) {
            this.updateParams({perPage: params.currentPerPage});
            this.paginatedData();
        },
        onSortChange(params) {
            this.serverParams.sort = {
                type: params[0].type,
                field: params[0].field,
            }
            this.paginatedData();
        },
        async paginatedData() {
            try {
                let url = route('admin.insurance-item-categories.index') +
                    `?q=${this.searchTerm}&page=${this.serverParams.page}&perPage=${this.serverParams.perPage}`;
                let {data: {data: {categories}}} = await axios.get(url);

                this.totalRecords = categories.total;
                this.paginationOptions.perPage = categories.per_page;
                this.allInsuranceItemCategories = categories.data
            } catch (e) {
                console.log(e);
            }
        },

        serialNo(props) {
            return this.serverParams.page === 1 ? props.index + 1 : (this.serverParams.perPage *
                    (this.serverParams.page - 1)) +
                props.index + 1
        },
    }
}
</script>
